<ng-container *ngIf="editMode">
  <p-skeleton height="32px" [width]="minWidth" styleClass="skeleton-with-border" *ngIf="!fonctionsLoaded"></p-skeleton>
  <p-dropdown
    scrollHeight="400px"
    inputId="fonctionsDropdown{{ guid }}"
    name="fonctionsDropdown{{ guid }}"
    [options]="fonctions"
    [(ngModel)]="fonction"
    [required]="required"
    [disabled]="disabled"
    dataKey="Id"
    [showClear]="showClear"
    [resetFilterOnHide]="true"
    [emptyFilterMessage]="'Aucun résultat'"
    appendTo="body"
    [placeholder]="placeholder"
    emptyMessage="Aucun résultat trouvé"
    [autoDisplayFirst]="false"
    [style]="pDropdownStyle"
    #fonctionCtrl="ngModel"
    (ngModelChange)="fonctionChanged()"
    *ngIf="fonctionsLoaded"
    styleClass="no-ellipsis"
  >
    <ng-template let-item pTemplate="selectedItem">
      <span>{{ item?.Nom }}</span>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="ui-helper-clearfix">
        <span>{{ item.Nom }}</span>
      </div>
    </ng-template>
  </p-dropdown>
</ng-container>
<ng-container *ngIf="_fonction && !editMode">
  <span>{{ _fonction.Nom }}</span>
</ng-container>
